const PREFIX = "EVENT";
export class SAVE_EVENT {
  public static readonly type = `[${PREFIX}] SAVE EVENT`;
  constructor(public readonly payload) {}
}
export class UPDATE_EVENT {
  public static readonly type = `[${PREFIX}] UPDATE EVENT`;
  constructor(public readonly payload) {}
}

export class GET_EVENT_MANAGEMENT {
  public static readonly type = `[${PREFIX}] GET EVENT MANAGEMENT`;
  constructor(public readonly payload) {}
}

export class UPDATE_EVENT_MANAGEMENT {
  public static readonly type = `[${PREFIX}] UPDATE EVENT MANAGEMENT`;
  constructor(public readonly payload) {}
}
export class GET_ALL_EVENT_LIST {
  public static readonly type = `[${PREFIX}] GET ALL EVENT LIST`;
  constructor(public readonly payload) {}
}
export class SET_EVENT_ALERT_ARCHIVED {
  public static readonly type = `[${PREFIX}] SET EVENT ALERT ARCHIVED`;
  constructor(public readonly payload) {}
}

export class GET_EVENT_SUMMARY {
  public static readonly type = `[${PREFIX}] GET EVENT SUMMARY`;
  constructor(public readonly payload) {}
}

export class GET_EVENT_CHANNEL_LIST {
  public static readonly type = `[${PREFIX}] GET EVENT CHANNEL LIST`;
  constructor(public readonly payload) {}
}
